<div class="main-container gap-M">
    <div class="pad-L">
        <div class="bg-rounded">
            <app-announcement-list [announcements]="announcementList" [tenantId]="tenant.configuration.id" *ngIf="!isLoading"></app-announcement-list>
        </div>
    </div>
    <div class="marketing-banner bg-rounded overflow-hidden mt-l mr-l">
        <div class="marketing-inner">
            <div class="flex-justify-center flex-align-end" style="height: 112px;">
                <div class="marketing-icon bg-rounded flex-align-center flex-justify-center" >
                    <img class="filter-grey" src="assets/icons/satellite.svg" alt="Satellite" height="35" width="35">
                </div>
            </div>
            <div class="pad-XL mt-l">
                <div class="fw-700 font-L" style="line-height: 26px">
                    {{ 'page.announcement.marketing.title' | translate }}
                </div>
                <div class="mt-l">
                    {{ 'page.announcement.marketing.subtitle' | translate }}
                </div>
                <div class="flex-align-center flex-justify-start w-100 mt-l">
                    <app-text-button (click)="openDocumentation()" color="grey" size="compact" type="stroked">
                        <img src="assets/icons/info-black.svg" height="20" width="20" alt="Info">
                        <div class="ml-xs">{{ 'page.announcement.marketing.cta'| translate }}</div>
                    </app-text-button>
                </div>
            </div>
        </div>
    </div>
</div>